#import "../fragments/contact-page-form-submission-fragment.graphql"

query GetContactPageFormSubmissions($id: ID!, $first: Int, $after: String) {
    contact(id: $id) {
        id
        submissions(first: $first, after: $after) {
            totalCount
            pageInfo {
                hasNextPage
                endCursor
            }
            edges {
                node {
                    ...ContactPageFormSubmissionFragment
                }
            }
        }
    }
}
